import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VoterService {
  private permissions = [
    {
      id: 1,
      role: 'BACKOFFICE_GROUP_BOK',
      permissions: [
        'tabBar_devices',
        'tabBar_devicesXblitz',
        'tabBar_printingDevices',
        'tabBar_editPanel',
        'tabBar_SIMConfiguration',
        'tabBar_promoCodes',
        'tabBar_TMobileMigration',
        'tabBar_deviceConfiguration',
        'tabBar_exchangeSIMCard',
        'tabBar_shipmentSIMCardPackages',
        'tabBar_migrationOfCardNumbers'
      ]
    },
    {
      id: 2,
      role: 'SuperAdmin',
      permissions: [
        'tabBar_devices',
        'tabBar_printingDevices',
        'tabBar_editPanel',
        'tabBar_SIMConfiguration',
        'tabBar_promoCodes',
        'tabBar_TMobileMigration',
        'tabBar_deviceConfiguration',
        'tabBar_exchangeSIMCard',
        'tabBar_shipmentSIMCardPackages',
        'tabBar_migrationOfCardNumbers'
      ]
    },
    {
      id: 3,
      role: 'BOK',
      permissions: [
        'tabBar_devices',
        'tabBar_printingDevices',
        'tabBar_editPanel',
        'tabBar_SIMConfiguration',
        'tabBar_promoCodes',
        'tabBar_TMobileMigration',
        'tabBar_deviceConfiguration',
        'tabBar_shipmentSIMCardPackages'
      ]
    },
    {
      id: 4,
      role: 'Service',
      permissions: [
        'tabBar_devices',
        'tabBar_printingDevices',
        'tabBar_editPanel',
        'tabBar_SIMConfiguration',
        'tabBar_deviceConfiguration',
        'tabBar_exchangeSIMCard',
        'tabBar_shipmentSIMCardPackages'
      ]
    },
    {
      id: 5,
      role: 'BACKOFFICE_GROUP_XBLITZ',
      permissions: ['tabBar_devicesXblitz']
    },
    {
      id: 6,
      role: 'BACKOFFICE_ACCESS',
      permissions: ['access_backoffice']
    }
  ];

  /**
   * Get permissions for a specific role
   * @param role The role to get permissions for
   * @returns An array of permissions for the role
   */
  getPermissions(role: string): string[] {
    const roleConfig = this.permissions.find(p => p.role === role);
    return roleConfig ? roleConfig.permissions : [];
  }

  /**
   * Map an array of roles to an array of permissions
   * @param roles Array of role names
   * @returns Array of permissions derived from the roles
   */
  mapRolesToPermissions(roles: string[]): string[] {
    if (!roles || !Array.isArray(roles)) {
      return [];
    }

    // Flatten the array of permission arrays into a single array
    const allPermissions = roles.flatMap(role => this.getPermissions(role));

    // Remove duplicates
    return [...new Set(allPermissions)];
  }
}
